import http from "@/utils/axios";

const gameService = {
  getAllGames() {
    return http.get("/games").then((rs) => {
      return rs ? rs.data : [];
    });
  },
  getByCode(code) {
    return http.get(`/games/${code}`).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  createNewGame(game) {
    return http.post("/game", game, { requiresAuth: true }).then((rs) => (rs ? rs.data : []));
  },
  uploadGameImage(gameId, file = null, imageUrl = "") {
    const form = new FormData();
    form.append("gameId", String(gameId));

    if (file) form.append("file", file);
    if (imageUrl) form.append("url", String(imageUrl));

    return http
      .post("/game/upload-image", form, { requiresAuth: true })
      .then((rs) => (rs ? rs.data : null));
  },
copyGame(data) {
  return http.post("/game/copy", data, { requiresAuth: true }).then((rs) => rs);
},
  joinGame(game) {
    return http.post(`/game/join`, game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
 loadGame(game) {
  return http.post("/load-game", game, { requiresAuth: true }).then((rs) => (rs ? rs.data : []));
},
  loadGame2(data) {
    return http.post("/load-game-2", data, { requiresAuth: true }).then((rs) => {
      return rs;
    });
  },
  playerJoinGame(data) {
    return http.post(`/game/player-join`, data).then((rs) => {
      return rs;
    });
  },
  startGame(data) {
    return http.post(`/game/start`, data).then((rs) => {
      return rs;
    });
  },
  updateGameTexts(gameId, gameTexts, gameTitle = "") {
    const payload = { gameId, gameTexts, gameTitle };
    return http.post(`/game/update-texts`, payload).then((rs) => (rs ? rs.data : []));
  },
  getPlayerGroupDetails(data) {
    return http.post("/game/player-group-details", data).then((rs) => {
      return rs;
    });
  },
  rehydrateGame(data) {
    return http.post("/game/rehydrate", data).then((rs) => {
      return rs;
    });
  },
  sendMessage(message) {
    return http.post("/message", message).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  sendMessage2(data) {
    return http.post("/send-message", data).then((rs) => {
      return rs;
    });
  },
  submitPreliminaryVote(vote) {
    return http.post("/preliminary-vote", vote).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  submitVote(vote) {
    return http.post("/vote", vote).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  submitVote_v2(vote) {
    return http.post("/v2/vote", vote).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  revealVotes(reveal) {
    return http.post("/reveal", reveal).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  revealVotes2(data) {
    return http.post("/reveal-2", data).then((rs) => {
      return rs;
    });
  },
  getAllGroupsVotes(data) {
    return http.post("/get-all-groups-votes", data).then((rs) => {
      return rs;
    });
  },
  getGroupVotes(data) {
    return http.post("/get-group-votes", data).then((rs) => {
      return rs;
    });
  },
  updateTextVote(data) {
    return http.post("/update-text-vote", data).then((rs) => {
      return rs;
    });
  },
  revealNonVoters(game) {
    return http.post("/non-voters", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  nextPhase(game) {
    return http.post("/next-phase", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  gameTranscriptDownload(game) {
    return http.post("/download-transcript", game, { responseType: "blob" }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GameTranscript.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  },
  gameTranscriptDownload2(data) {
    return http.post("/download-transcript-2", data, { responseType: "blob" }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "GameTranscript.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  },
  messageTranscriptDownload(game) {
    return http.post("/download-messages", game, { responseType: "blob" }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "MessageTranscript.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  },
  messageTranscriptDownload2(data) {
    return http.post("/download-messages-2", data, { responseType: "blob" }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "MessageTranscript.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  },
  verifyTranscriptsPassword(password) {
    return http.post("/verify-transcripts-password", { password }).then((rs) => rs.data);
  },
  allMessagesDownload2(payload, token) {
    return http.post(
      "/download-all-messages-2",
      payload,
      {
        responseType: "blob",
        headers: {
          "x-transcripts-token": token,
        },
      }
    ).then(async (response) => {
      const contentType = response.headers["content-type"] || "";

      // If backend returned JSON instead of Excel
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      }

      // Excel file case
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AllMessages.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    });
  },
  allTranscriptsDownload(game) {
    return http.post("/download-all-transcripts", game, { responseType: "blob" }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AllTranscripts.xlsx");
      document.body.appendChild(link);
      link.click();
    });
  },
  allTranscriptsDownload2(payload, token) {
    return http.post(
      "/download-all-transcripts-2",
      payload,
      {
        responseType: "blob",
        headers: {
          "x-transcripts-token": token,
        },
      }
    ).then(async (response) => {
      const contentType = response.headers["content-type"] || "";

      // If backend returned JSON instead of Excel
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        return JSON.parse(text);
      }

      // Excel file case
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AllTranscripts.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    });
  },
  getMessages(game) {
    return http.post("/get-messages", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  getCurrentPhase(game) {
    return http.post("/get-current-phase", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  setSaboteur(game) {
    return http.post("/set-saboteur", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  setSaboteur2(data) {
    return http.post("/set-saboteur-2", data).then((rs) => {
      return rs;
    });
  },
  getPlayerRole(game) {
    return http.post("/get-role", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  getPlayerRole2(data) {
    return http.post("/get-role-2", data).then((rs) => {
      return rs;
    });
  },
  calculateScores(data) {
    return http.post("/calculate-scores", data).then((rs) => {
      return rs;
    });
  },
  preparePrelimVotes(data) {
    return http.post("/prepare-prelim-votes", data).then((rs) => {
      return rs;
    });
  },
  preparePlayersRole(data) {
    return http.post("/prepare-players-role", data).then((rs) => {
      return rs;
    });
  },
  prepareSaboteurVotes(data) {
    return http.post("/prepare-saboteur-votes", data).then((rs) => {
      return rs;
    });
  },
  getScore(game) {
    return http.post("/get-scores", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  getGameScores(data) {
    return http.post("/get-scores-2", data).then((rs) => {
      return rs;
    });
  },
  getAllGroupsScores(data) {
    return http.post("/get-all-groups-scores", data).then((rs) => {
      return rs;
    });
  },
  getGroupScores(data) {
    return http.post("/get-group-scores", data).then((rs) => {
      return rs;
    });
  },
  getSaboteurName(game) {
    return http.post("/get-saboteur-name", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  allPlayersVoted(game) {
    return http.post("/all-players-voted", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  allPlayersVoted2(data) {
    return http.post("/all-players-voted-2", data).then((rs) => {
      return rs;
    });
  },
  allPlayersPrelimVoted(game) {
    return http.post("/all-players-prelim-voted", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  allPlayersPrelimVoted2(data) {
    return http.post("/all-players-prelim-voted-2", data).then((rs) => {
      return rs;
    });
  },
  getPrelimVotes(gameId) {
    return http.post("/get-prelim-votes", { gameId }).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  saveGame(game) {
    return http.post("/save-game", game).then((rs) => {
      return rs ? rs.data : [];
    });
  },
  getPrelimVotes2(data) {
    // console.log("Sending request to /get-prelim-votes-2 with data:", data);
    return http.post("/get-prelim-votes-2", data).then((rs) => {
      return rs;
    });
  },
  test(data) {
    return http.post("/test-api", data).then((rs) => {
      return rs;
    });
  },

  // auth API calls
  // getUser() {
  //   return http
  //     .post("/auth/fetch-user", null, { auth: true, headers: { "Content-Type": "application/json" } })
  //     .then((rs) => ({
  //       status: rs.status,
  //       data: rs.data,
  //     }))
  //     .catch((err) => {
  //       if (err.response) {
  //         return {
  //           status: err.response.status,
  //           data: err.response.data,
  //         };
  //       } else {
  //         throw err; // for network errors, timeouts, etc.
  //       }
  //     });
  // },

 getUser() {
  return http
    .post("/auth/fetch-user", null, { requiresAuth: true })
    .then((rs) => ({
      status: rs.status,
      data: rs.data,
    }))
    .catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      }
      throw err;
    });
},


  loginUser(data) {
    return http
      .post("/auth/login", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },

  verifySignupEmail(data) {
    return http
      .post("/auth/verify-email", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },

  verifyFPEmail(data) {
    return http
      .post("/auth/fp/verify-email", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },

  sendSignupVerificationCode(data) {
    return http
      .post("/auth/send-verification-code", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },

  sendFPVerificationCode(data) {
    return http
      .post("/auth/fp/send-verification-code", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },

  signupVerifyCode(data) {
    return http
      .post("/auth/verify-code", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },

  fPVerifyCode(data) {
    return http
      .post("/auth/fp/verify-code", data)
      .then((rs) => ({
        status: rs.status,
        data: rs.data,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err; // for network errors, timeouts, etc.
        }
      });
  },
  getAllUsers() {
    return http
      .get("/admin/users", { requiresAuth: true })
      .then((rs) => ({
        status: rs.status || 200,
        data: rs.data || rs,
      }))
      .catch((err) => {
        if (err.response) {
          return {
            status: err.response.status,
            data: err.response.data,
          };
        } else {
          throw err;
        }
      });
  },
  getAllSessions(params = {}) {
    const config = { requiresAuth: true };
    if (Object.keys(params).length > 0) {
      config.params = params;
    }
    return http.get("/admin/sessions", config).then((rs) => {
      return {
        status: rs.status || 200,
        data: rs.data || rs,
      };
    }).catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      } else {
        throw err;
      }
    });
  },
  getSessionHostAccounts() {
    return http.get("/admin/session-host-accounts", { requiresAuth: true }).then((rs) => {
      return {
        status: rs.status || 200,
        data: rs.data || rs,
      };
    }).catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      }
      throw err;
    });
  },
  getMySessions() {
    return http.get("/teacher/my-sessions", { requiresAuth: true }).then((rs) => {
      return {
        status: rs.status || 200,
        data: rs.data || rs,
      };
    }).catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      } else {
        throw err;
      }
    });
  },
  getPublicSessions() {
    return http.get("/teacher/public-sessions", { requiresAuth: true }).then((rs) => {
      return {
        status: rs.status || 200,
        data: rs.data || rs,
      };
    }).catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      } else {
        throw err;
      }
    });
  },

  addBookmark(gameId) {
    return http.post(`/teacher/bookmark/${gameId}`, {}, { requiresAuth: true }).then((rs) => ({ status: rs.status || 200, data: rs.data || rs })).catch((err) => {
      if (err.response) return { status: err.response.status, data: err.response.data };
      throw err;
    });
  },

  removeBookmark(gameId) {
    return http.delete(`/teacher/bookmark/${gameId}`, { requiresAuth: true }).then((rs) => ({ status: rs.status || 200, data: rs.data || rs })).catch((err) => {
      if (err.response) return { status: err.response.status, data: err.response.data };
      throw err;
    });
  },

  getAllTeacherApplications() {
    return http.get("/admin/teacher-applications", { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      throw error;
    });
  },
  updateUserRole(userId, role) {
    return http.patch(`/admin/users/${userId}/role`, { role }, { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        throw error.response.data;
      }
      throw error;
    });
  },
  applyTeacher(payload) {
    return http.post("/teacher-application", payload, { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  getApplicationStatus() {
    return http.get("/teacher-application/status", { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  getTeacherApplicationDetail(applicationId) {
    return http.get(`/admin/teacher-applications/${applicationId}`, { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  getReviewTemplates() {
    return http.get("/admin/review-templates", { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  createReviewTemplate(payload) {
    return http.post("/admin/review-templates", payload, { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  updateReviewTemplate(templateId, payload) {
    return http.put(`/admin/review-templates/${templateId}`, payload, { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  deleteReviewTemplate(templateId) {
    return http.delete(`/admin/review-templates/${templateId}`, { requiresAuth: true }).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  acceptTeacherApplication(applicationId, message = null) {
    return http.post(
      `/admin/teacher-applications/${applicationId}/accept`,
      { message },
      { requiresAuth: true }
    ).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  declineTeacherApplication(applicationId, message = null) {
    return http.post(
      `/admin/teacher-applications/${applicationId}/decline`,
      { message },
      { requiresAuth: true }
    ).then((rs) => {
      return rs ? rs.data : null;
    }).catch((error) => {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    });
  },
  downloadTranscript(gameId, timeZone = "UTC") {
    return http.post(
      "/download-transcript-2",
      { gameId: gameId, timeZone },
      { requiresAuth: true, responseType: "blob" }
    ).then((response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `GameTranscript_${gameId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return response;
    });
  },
  downloadChat(gameId, timeZone = "UTC") {
    return http.post(
      "/download-messages-2",
      { gameId: gameId, timeZone },
      { requiresAuth: true, responseType: "blob" }
    ).then((response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `GameChat_${gameId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return response;
    });
  },
  getGameReplay(gameId) {
    return http.get(`/games/${gameId}/replay`, { requiresAuth: true }).then((response) => response.data.replay);
  },
  getGameDetails(gameId) {
    return http.get(`/admin/game-details/${gameId}`, { requiresAuth: true }).then((rs) => {
      return {
        status: rs.status || 200,
        data: rs.data || rs,
      };
    }).catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      } else {
        throw err;
      }
    });
  },

  switchGameVisibility(gameId, metadata = {}) {
    return http.patch(`/admin/game-details/${gameId}/visibility`, metadata, { requiresAuth: true }).then((rs) => {
      return { status: rs.status || 200, data: rs.data || rs };
    }).catch((err) => {
      if (err.response) {
        return { status: err.response.status, data: err.response.data };
      }
      throw err;
    });
  },

  generateGameReport(gameId) {
    return http.get(`/admin/game-report/${gameId}`, { requiresAuth: true }).then((rs) => {
      return {
        status: rs.status || 200,
        data: rs.data || rs,
      };
    }).catch((err) => {
      if (err.response) {
        return {
          status: err.response.status,
          data: err.response.data,
        };
      } else {
        throw err;
      }
    });
  },

  // Sharing groups (teachers/researchers) — optional: if backend hasn't run migration, available is false
  buildRoleContextConfig(roleContext) {
    const normalizedRoleContext = typeof roleContext === "string" ? roleContext.trim().toLowerCase() : "";
    if (!normalizedRoleContext) return { requiresAuth: true };
    return {
      requiresAuth: true,
      headers: {
        "X-Role-Context": normalizedRoleContext,
      },
    };
  },
  sharingGroupsAvailable() {
    return http.get("/sharing-groups/available", { requiresAuth: true }).then((rs) => rs?.data ?? rs).catch(() => ({ success: false, available: false }));
  },
  createSharingGroup(data, roleContext = null) {
    return http.post("/sharing-groups", data, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  joinSharingGroup(data, roleContext = null) {
    return http.post("/sharing-groups/join", data, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  getMySharingGroups(roleContext = null) {
    return http.get("/sharing-groups", this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  getSharingGroup(groupId, roleContext = null) {
    return http.get(`/sharing-groups/${groupId}`, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  updateSharingGroup(groupId, payload, roleContext = null) {
    return http.patch(`/sharing-groups/${groupId}`, payload, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  deleteSharingGroup(groupId, roleContext = null) {
    return http.delete(`/sharing-groups/${groupId}`, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  getSharingGroupGames(groupId, roleContext = null) {
    return http.get(`/sharing-groups/${groupId}/games`, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  shareGameToGroup(groupId, gameId, metadata = {}, roleContext = null) {
    return http.post(`/sharing-groups/${groupId}/games`, { gameId, ...metadata }, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  shareGamePersonal(gameId, email) {
    return http.post("/sharing/personal", { gameId, email }, { requiresAuth: true }).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response && err.response.data) throw err.response.data;
      throw err;
    });
  },
  getSharedWithMe(roleContext = null) {
    return http.get("/sharing/shared-with-me", this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  getSharingGroupMembers(groupId, roleContext = null) {
    return http.get(`/sharing-groups/${groupId}/members`, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
  inviteToSharingGroup(groupId, payload, roleContext = null) {
    return http.post(`/sharing-groups/${groupId}/invite`, payload, this.buildRoleContextConfig(roleContext)).then((rs) => rs?.data ?? rs).catch((err) => {
      if (err.response) throw err.response.data;
      throw err;
    });
  },
};

export default gameService;
